import { cva } from 'class-variance-authority';

/**
 * Base styles for the card component
 */
export const cardStyles = cva([
  'flex',
  'flex-col',
  'w-full',
].join(' '), {
  variants: {
    withBackground: {
      true: 'bg-neutral-white',
      false: 'bg-transparent',
    },
    withBorder: {
      true: 'border border-neutral-gray-200 border-solid shadow-sm',
      false: 'border-none',
    },
    padding: {
      none: 'p-0',
      small: 'p-4',
      medium: 'p-6',
      large: 'p-8',
    },
    radius: {
      none: 'rounded-none',
      small: 'rounded',
      medium: 'rounded-lg',
      large: 'rounded-xl',
    },
  },
  defaultVariants: {
    withBackground: true,
    withBorder: true,
    padding: 'medium',
    radius: 'medium',
  },
});

/**
 * Styles for the card header (title area)
 */
export const cardHeaderStyles = cva([
  'flex',
  'flex-col',
  'gap-5',
  'w-full',
].join(' '));

/**
 * Styles for the card content (body area)
 */
export const cardContentStyles = cva([
  'flex',
  'flex-col',
  'gap-3',
  'items-start',
  'justify-center',
  'w-full',
].join(' '), {
  variants: {
    withContentBorder: {
      true: 'border border-neutral-gray-500 p-5 rounded-lg',
      false: '',
    },
  },
  defaultVariants: {
    withContentBorder: false,
  },
});
